import { render, staticRenderFns } from "./DepartDataruleModal.vue?vue&type=template&id=ed1c7c94&scoped=true"
import script from "./DepartDataruleModal.vue?vue&type=script&lang=js"
export * from "./DepartDataruleModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed1c7c94",
  null
  
)

export default component.exports